import { forEach } from 'lodash';
import {
    Essentials,
    ClassicEditor,
    Bold,
    Italic,
    Underline,
    Strikethrough,
    List,
    Subscript,
    Superscript,
    Image,
    ImageUpload,
    ImageCaption,
    ImageResize,
    ImageStyle,
    ImageBlock,
    ImageBlockEditing,
    ImageCaptionEditing,
    ImageUtils,
    ImageToolbar,
    ImageCaptionUI,
    ImageCaptionUtils,
    ImageCustomResizeUI,
    ImageResizeEditing,
    ImageResizeButtons,
    ImageResizeHandles,
    RemoveFormat,
    Table,
    BlockQuote,
    SpecialCharacters,
    PasteFromOffice,
    HorizontalLine,
    Undo,
    Base64UploadAdapter,
    Paragraph,
    ListCommand,
    ListProperties,
    ListSeparatorView,
    ListEditing,
    ListItemGroupView,
    ListPropertiesEditing,
    ListItemView,
    ListPropertiesUI,
    ListUI,
    ListPropertiesUtils,
    AdjacentListsSupport,
    ListIndentCommand,
    ListView,
    ListUtils,
    SpecialCharactersEssentials,
} from './ckeditor5/ckeditor5';
import translations from './ckeditor5/translations/pt-br';

window.createTextCourseEditor = async (selector) => {
    let editor = await ClassicEditor.create(document.querySelector(selector), {
        plugins: [
            Essentials,
            PasteFromOffice,
            Bold,
            Underline,
            Strikethrough,
            Italic,
            List,
            ListCommand,
            ListProperties,
            ListSeparatorView,
            ListEditing,
            ListItemGroupView,
            ListPropertiesEditing,
            ListItemView,
            ListPropertiesUI,
            ListUI,
            ListPropertiesUtils,
            ListUtils,
            ListView,
            ListIndentCommand,
            AdjacentListsSupport,
            Subscript,
            Superscript,
            Image,
            ImageUpload,
            ImageCaption,
            ImageResize,
            ImageResizeEditing,
            ImageResizeButtons,
            ImageResizeHandles,
            ImageStyle,
            ImageBlock,
            ImageBlockEditing,
            ImageCaptionEditing,
            ImageToolbar,
            ImageCaptionUI,
            ImageCaptionUtils,
            ImageCustomResizeUI,
            ImageUtils,
            RemoveFormat,
            Table,
            BlockQuote,
            SpecialCharacters,
            SpecialCharactersEssentials,
            HorizontalLine,
            Undo,
            Base64UploadAdapter,
            Paragraph,
        ],
        toolbar: {
            items: [
                'bold',
                'underline',
                'strikethrough',
                'italic',
                '|',
                'bulletedList',
                'numberedList',
                'subscript',
                'superscript',
                '|',
                'imageInsert',
                'removeFormat',
                '|',
                'insertTable',
                'blockQuote',
                'specialCharacters',
                'horizontalLine',
                '|',
                'undo',
                'redo',
            ]
        },
        translations,
        resizeOptions: [
            {
                name: 'resizeImage:original',
                value: null,
                label: 'Original'
            },
            {
                name: 'resizeImage:50',
                value: '50',
                label: '50%'
            },
            {
                name: 'resizeImage:25',
                value: '25',
                label: '25%'
            },
        ],
        image: {
            styles: [
                'alignCenter',
                'inline',
            ],
            insert: {
                integrations: [ 'upload', 'assetManager', 'url' ]
            },
            toolbar: [
                'imageStyle:inline',
                'imageStyle:alignCenter',
                '|',
                'resizeImage:original',
            ],
        },
        title: false,
    }).then(editor => {
        window[selector] = editor;
    }).catch(error => {
        console.error(error);
    });
}

window.populateEditor = (selector, content) => {
    window[selector].setData(content);
}

window.getDataEditor = (selector) => {
    const manipulatedContent = document.createElement('div');
    manipulatedContent.innerHTML = window[selector].getData();

    const headers = manipulatedContent.querySelectorAll('img');

    Array.from(headers).filter(img => img.height !== '').map((img, index) => {
        img.removeAttribute('height');
    });

    return manipulatedContent.innerHTML;
}

window.cleanEditor = (selector) => {
    if (window[selector]) {
        window[selector].destroy()
            .catch(error => {
                console.error(error);
            });
    }
}
